export const TEST_IDS = {
  nav: {
    logo: "nav-logo",
    home: "nav-link-home",
    chiSiamo: "nav-link-chi-siamo",
    impianti: "nav-link-impianti",
    cantieri: "nav-link-cantieri",
    contatti: "nav-link-contatti",
    admin: "nav-link-admin",
    cta: "nav-cta-contact",
    mobileToggle: "nav-mobile-toggle",
  },
  hero: {
    section: "hero-section",
    title: "hero-title",
    subtitle: "hero-subtitle",
    ctaPrimary: "hero-cta-primary",
    ctaSecondary: "hero-cta-secondary",
    scrollHint: "hero-scroll-hint",
  },
  chi: {
    section: "chi-siamo-section",
    chapter: (n) => `chi-chapter-${n}`,
  },
  impianti: {
    section: "impianti-section",
    card: (slug) => `impianti-card-${slug}`,
  },
  cantieri: {
    section: "cantieri-section",
    grid: "cantieri-grid",
    item: (id) => `cantieri-item-${id}`,
    empty: "cantieri-empty",
  },
  contatti: {
    section: "contatti-section",
    form: "contatti-form",
    name: "contatti-input-name",
    email: "contatti-input-email",
    phone: "contatti-input-phone",
    message: "contatti-input-message",
    submit: "contatti-submit",
  },
  admin: {
    loginForm: "admin-login-form",
    loginEmail: "admin-login-email",
    loginPassword: "admin-login-password",
    loginSubmit: "admin-login-submit",
    logout: "admin-logout",
    uploadForm: "admin-upload-form",
    uploadTitle: "admin-upload-title",
    uploadLocation: "admin-upload-location",
    uploadDescription: "admin-upload-description",
    uploadFile: "admin-upload-file",
    uploadSubmit: "admin-upload-submit",
    deleteItem: (id) => `admin-delete-${id}`,
  },
};
